import { base44 } from "@/api/base44Client";

// Returns false when the current user is logged in, so their activity
// is excluded from page-view and click analytics.
export async function shouldTrack() {
  try {
    return !(await base44.auth.isAuthenticated());
  } catch {
    return true;
  }
}

// Maps a route pathname to the page key used in ResourceEvent
export function pageKeyFromPath(pathname) {
  const resourceMatch = pathname.match(/^\/resources\/([^/]+)$/);
  if (resourceMatch && resourceMatch[1] !== "tools") return `resource:${resourceMatch[1]}`;
  return pathname.replace(/\/$/, "") || "/";
}

// Records a page view session event and tracks time spent on the page.
// Returns a cleanup function to call when the page is left (route change or unmount).
export function trackPageView(page) {
  let eventId = null;
  const startTime = Date.now();

  shouldTrack().then((track) => {
    if (!track) return;
    base44.entities.ResourceEvent.create({
      page,
      event_type: "session",
      session_id: `pv-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    }).then((rec) => { eventId = rec?.id || null; }).catch(() => {});
  });

  const sendDuration = () => {
    if (!eventId) return;
    const duration = Math.round((Date.now() - startTime) / 1000);
    if (duration > 0) {
      base44.entities.ResourceEvent.update(eventId, { duration_seconds: duration }).catch(() => {});
    }
    eventId = null;
  };

  window.addEventListener("beforeunload", sendDuration);
  return () => {
    sendDuration();
    window.removeEventListener("beforeunload", sendDuration);
  };
}